import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { store } from '../redux/store';
import { api } from './api';

interface TriggerLiveviewResponse {
  status: number;
  message: string;
}

export const liveviewApi = createApi({
  reducerPath: 'liveviewApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_LIVEVIEW_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = (getState as typeof store.getState)();
      headers.set('Authorization', `Bearer ${state.authReducer.token}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    triggerLiveview: builder.query<TriggerLiveviewResponse, string>({
      query: plateNo => ({
        url: `trigger/${plateNo}`,
        method: 'GET',
      }),
    }),
    getLiveview: builder.query<string, { plateNo: string; cam: string }>({
      query: ({ plateNo, cam }) => ({
        url: `${plateNo}/${cam}`,
        method: 'GET',
      }),
    }),
  }),
});

export const liveviewUsageApi = api.injectEndpoints({
  endpoints: builder => ({
    createTimeStamp: builder.mutation<void, { vehicle_id: string }>({
      query: ({ vehicle_id }) => ({
        url: `liveview_usage/`,
        method: 'POST',
        body: {
          vehicle: vehicle_id,
        },
      }),
    }),
  }),
});

export const { useCreateTimeStampMutation } = liveviewUsageApi;

export const { useLazyTriggerLiveviewQuery, useLazyGetLiveviewQuery } = liveviewApi;
